
<template>
  <div class="home"  v-title :data-title="title">
    <bannera />
    <contenta />
    <footera />
  </div>
</template>

<script>
import "../../assets/js/pcRem";
import "../../assets/styles/common.css";
import "../../assets/js/base64";

import bannera from "../../components/pc/banner.vue";
import contenta from "../../components/pc/content.vue";
import footera from "../../components/pc/footer.vue";
export default {
  name: "App",
  components: {
    bannera,
    contenta,
    footera
  },
  data() {
    return {
      title:''
    }
    
  },
  created() {
    if (window.location.host == "sxdc.w.chineseall.cn") {
      this.title = "来书香东城“赛龙舟”，读点好书更出“粽”";
    } else {
      this.title = "来书香中国“赛龙舟”，读点好书更出“粽”";
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.home {
  margin: auto;
}
</style>

